'use strict';

var config;
if (process.env.NODE_ENV === 'production') {
    config = {
        'apiBase': 'https://api.devnew.dokiv.se/v1',
        'shareURLBase': 'https://share.devnew.dokiv.com/',
        'formApiBase': 'http://api.devnew.dokiv.se/v1',
        'appId': '3f49d195-e061-49ea-9ba8-987ded37c9e9',
        'portalUrl': 'https://portal.devnew.dokiv.se'
    };
} else {
    console.log('Using dev config');
    config = {
        'apiBase': 'https://api.devnew.dokiv.se/v1',
        'shareURLBase': 'https://share.devnew.dokiv.com/',
        'formApiBase': 'http://api.devnew.dokiv.se/v1',
        'appId': '3f49d195-e061-49ea-9ba8-987ded37c9e9',
        'portalUrl': 'https://portal.devnew.dokiv.se'
    };
}

angular.module('dokiv')
    .value('config', config);



//////////////////
// WEBPACK FOOTER
// ./scripts/config.js
// module id = 68
// module chunks = 0